// 使用者要存哪些資料 -- 對應後台 models/users
export default () => {
  return {
    token: '',
    account: '',
    role: 0,
    cart: 0
  }
}
